import type { ShopperProducts } from '@/scapi';
import { createCategoryUrl, isCategoryPlpPathname, normalizeCategoryPath } from '@/lib/category-url';

export const PRIMARY_SHOPPING_CATEGORY_COOKIE_NAME = 'primary-shopping-category';
export const PRIMARY_SHOPPING_PILLAR_COOKIE_NAME = 'primary-shopping-pillar';

type Category = ShopperProducts.schemas['Category'];

/** First-level category below the catalog root in the category's tree (the category itself when it is L1). */
export function findPrimaryCategoryNode(category: Category) {
    return (
        category.parentCategoryTree?.find((node) => node.id != null && node.id !== 'root') ??
        (category.parentCategoryId === 'root' ? category : undefined)
    );
}

/**
 * Resolves the storefront pathname for the primary category (first level below catalog root).
 * Used for the primary-shopping-category cookie and Start Shopping navigation.
 */
export function resolvePrimaryCategoryEntryUrl(category: Category): string | null {
    const primaryCategory = findPrimaryCategoryNode(category);
    if (!primaryCategory) {
        return null;
    }
    const url = createCategoryUrl(primaryCategory);
    return url === '#' ? null : url;
}

export function isValidPrimaryShoppingCategoryPath(path: string | null | undefined): path is string {
    if (!path || path === '#') {
        return false;
    }
    const normalized = normalizeCategoryPath(path);
    return normalized != null && normalized.length > 0 && isCategoryPlpPathname(normalized);
}
